// Totales de lo filtrado en una linea de etiquetas pequenas (Daniel, 12/10/2026):
// nombre, valor y, si hay, un dato secundario entre parentesis.
export function ChipsDeTotales({datos, prueba}: {datos: Array<[string, string, string?]>; prueba?: string}) {
  return (
    <div className="flex flex-wrap gap-1.5" data-prueba={prueba}>
      {datos.map(([nombre, valor, secundario]) => (
        <div key={nombre} className="rounded-md border border-linea bg-white px-2 py-0.5 text-xs">
          <span className="text-apagado">{nombre}</span>{' '}
          <span className="text-sm font-semibold tabular-nums text-verde-oscuro">{valor}</span>
          {secundario && <span className="ml-1 tabular-nums text-apagado">({secundario})</span>}
        </div>
      ))}
    </div>
  );
}
